import React, { useState } from "react";
import { LockOutlined, UserOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';

const RegisterScreen = ({ setLoginState }) => {
  
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const modal = Modal;

 

  const handleRegister = async (values) => {
    if (values.wachtwoord !== values.confirmPassword) {
      openNotificationError("Wachtwoorden komen niet overeen!")
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/users/register`, {
        naam: values.naam,
        email: values.email,
        wachtwoord: values.wachtwoord,
      })
      
     
      navigate("/goedkeuring");
    } catch (error) {
      console.error("API Error:", error);
      openNotificationError("Fout bij het registeren!", error)
    }
  };

  return (
    <div className="container">
      <div className="input-container">
        <img src="/img/logo.png" alt="Logo" />
        <h1 className="title">Registratie</h1>
        <Form form={form} name="register_form" layout="vertical" onFinish={handleRegister}>
          <Form.Item 
            name="naam" 
            rules={[
              { required: true, message: "Voer uw naam in!" },
              { min: 5, message: "Naam moet minimaal 5 tekens bevatten!" }
            ]}
          > 
            <Input 
              size="large"
              placeholder="Naam" 
              prefix={<UserOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item 
            name="email" 
            rules={[
              { required: true, message: "Voer uw e-mail in!" },
              { type: "email", message: "Voer een geldig e-mail adres in!" },
              { 
                pattern: /@kouterkortrijk\.be$/, 
                message: "E-mail moet eindigen met @kouterkortrijk.be!" 
              }
            ]}
          > 
            <Input 
              size="large"
              placeholder="Email" 
              prefix={<MailOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item 
            name="wachtwoord" 
            rules={[
              { required: true, message: "Voer uw wachtwoord in!" },
              { min: 5, message: "Wachtwoord moet minimaal 5 tekens bevatten!" }
            ]}
          > 
            <Input.Password 
              size="large"
              placeholder="Wachtwoord" 
              prefix={<LockOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item 
            name="confirmPassword" 
            dependencies={["wachtwoord"]} 
            rules={[
              { required: true, message: "Bevestig uw wachtwoord!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("wachtwoord") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Paswoorden komen niet overeen!"));
                },
              }),
            ]}
          > 
            <Input.Password 
              size="large"
              placeholder="Bevestig wachtwoord" 
              prefix={<LockOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="button" 
              size="large"
              style={{ width: "100%" }}
            >
              Registreer
            </Button>
          </Form.Item>
        </Form>

        <Link className="registerlink" to="/login">
          Al een account? Log in.
        </Link>
      </div>
    </div>
  );
};

export default RegisterScreen;
